import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import PointsContainer from "@jumbo/Dashboards/Point";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.point"} />, isActive: true },
];

const Point = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.point" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.point.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <PointsContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Point;